export const FooterBottom = () => {
  return (
    <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
      <p>© 2024 Ekselencia. Todos los derechos reservados.</p>
      <p className="mt-2">Terra Incognita Creations LLC - Miami Beach, Florida, United States</p>
    </div>
  );
};
